import "core-js/modules/es.array.push.js";
import { enterpriseHome } from "@/libs/menu-list.js";
export default {
  name: "heard-logo",
  props: {
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onChange() {
      if (this.$store.state.user.userInfo.unitId) {
        this.$store.commit("setActiveMenu", enterpriseHome);
        this.$router.push({
          path: enterpriseHome.link
        });
      }
    }
  }
};